export default __webpack_public_path__ + "static/media/capaLogin.57b2ac2f.jpg";